import React, { useState, useEffect } from 'react';
import { Layout as AntLayout, Menu, Button, Dropdown, Avatar, Space } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CreditCardOutlined,
  BankOutlined,
  UserOutlined,
  LogoutOutlined,

  HomeOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import type { MenuProps } from 'antd';

const { Header, Sider, Content } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // 菜单项配置
  const menuItems: MenuProps['items'] = [
    {
      key: '/account',
      icon: <UserOutlined />,
      label: '账户中心',
      children: [
        {
          key: '/account/overview',
          label: '账户概览',
        },
        {
          key: '/account/cards',
          label: '银行卡管理',
        },
        {
          key: '/account/recharge',
          label: '充值',
        },
        {
          key: '/account/withdraw',
          label: '提现',
        },
      ],
    },
    {
      key: '/transactions',
      icon: <BankOutlined />,
      label: '账单查询',
    },
    {
      key: '/payment',
      icon: <CreditCardOutlined />,
      label: '支付流程',
    },
  ];

  // 处理菜单点击
  const handleMenuClick = (info: any) => {
    const { key } = info;
    console.log('Menu clicked:', key); // 添加调试日志
    navigate(key);
  };

  // 处理菜单展开/收起
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  
  const handleOpenChange = (keys: string[]) => {
    console.log('Open keys changed:', keys); // 添加调试日志
    setOpenKeys(keys);
  };

  // 用户下拉菜单
  const userMenuItems: MenuProps['items'] = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: () => {
        localStorage.clear();
        window.location.href = '/login';
      },
    },
  ];

  // 获取当前选中的菜单项
  const getSelectedKeys = () => {
    const pathname = location.pathname;
    if (pathname.startsWith('/account/cards')) return ['/account/cards'];
    if (pathname.startsWith('/account/recharge')) return ['/account/recharge'];
    if (pathname.startsWith('/account/withdraw')) return ['/account/withdraw'];
    if (pathname.startsWith('/account')) return ['/account/overview'];
    if (pathname.startsWith('/bill-query')) return ['/transactions'];
    if (pathname.startsWith('/transactions')) return ['/transactions'];
    if (pathname.startsWith('/payment')) return ['/payment'];
    return [pathname];
  };

  // 获取当前展开的菜单项
  useEffect(() => {
    const getDefaultOpenKeys = () => {
      const pathname = location.pathname;
      if (pathname.startsWith('/account')) {
        return ['/account'];
      }
      return [];
    };
    const defaultKeys = getDefaultOpenKeys();
    setOpenKeys(defaultKeys);
  }, [location.pathname]);

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={250}
        theme="light"
        style={{
          boxShadow: '2px 0 6px rgba(0,21,41,.08)',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 100,
        }}
      >
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: collapsed ? 'center' : 'flex-start',
            padding: collapsed ? 0 : '0 16px',
            borderBottom: '1px solid #e8e8e8',
            background: '#fff',
          }}
        >
          <HomeOutlined
            style={{
              fontSize: 24,
              color: '#1890ff',
              marginRight: collapsed ? 0 : 12,
            }}
          />
          {!collapsed && (
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#1890ff',
              }}
            >
              上海数据交易所
            </div>
          )}
        </div>

        <Menu
          mode="inline"
          selectedKeys={getSelectedKeys()}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          items={menuItems}
          onSelect={handleMenuClick}
          style={{
            border: 'none',
            marginTop: 8,
          }}
        />
      </Sider>

      <AntLayout style={{ marginLeft: collapsed ? 80 : 250, transition: 'margin-left 0.2s' }}>
        <Header
          style={{
            background: '#fff',
            padding: '0 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 1px 4px rgba(0,21,41,.08)',
            position: 'sticky',
            top: 0,
            zIndex: 99,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 40,
              height: 40,
            }}
          />

          <Space>
            <span style={{ color: '#666', fontSize: 14 }}>欢迎使用会员门户系统</span>
            <Dropdown
              menu={{ items: userMenuItems }}
              placement="bottomRight"
              arrow
            >
              <Space style={{ cursor: 'pointer' }}>
                <Avatar
                  size={36}
                  icon={<UserOutlined />}
                  style={{ backgroundColor: '#1890ff' }}
                />
                <span style={{ color: '#262626', fontWeight: 500 }}>管理员</span>
              </Space>
            </Dropdown>
          </Space>
        </Header>

        <Content
          style={{
            minHeight: 'calc(100vh - 64px)',
            background: '#f5f5f5',
            overflow: 'auto',
          }}
        >
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;